import { render, staticRenderFns } from "./MoKan.vue?vue&type=template&id=b96ef8b8&"
import script from "./MoKan.vue?vue&type=script&lang=js&"
export * from "./MoKan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports